import React from 'react';
import { Link } from 'react-router-dom';
import { getAbsoluteUrl, isSameSite } from '../../utils/navigation';

export const SmartLink = ({ to, children, className, ...props }) => {
  if (!to) return <span className={className} {...props}>{children}</span>;

  if (isSameSite(to)) {
    return (
      <Link to={to} className={className} {...props}>
        {children}
      </Link>
    );
  } else {
    return (
      <a href={getAbsoluteUrl(to)} className={className} {...props}>
        {children}
      </a>
    );
  }
};

export default SmartLink;
